import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogDownloadedMediaComponent } from './change-log-downloaded-media.component';
import { ImageWithLoaderModule } from 'ag-common-svc/lib/components/image-with-loader/image-with-loader.module';
import { GetWasabiPathWithoutTimestampPipe } from './get-wasabi-path-without-timestamp.pipe';

@NgModule({
  declarations: [ChangeLogDownloadedMediaComponent, GetWasabiPathWithoutTimestampPipe],
  imports: [CommonModule, SharedModule, ImageWithLoaderModule],
  exports: [ChangeLogDownloadedMediaComponent, GetWasabiPathWithoutTimestampPipe],
})
export class ChangeLogDownloadedMediaModule {}
